module.exports = __webpack_public_path__ + "static/media/mode-19.c7cecd40.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-19.svg
// module id = 992
// module chunks = 2